import React from 'react';

import { formatDate } from 'mappers/commonMapper';
import { TextLine } from '../lineTemplates';
import { Sent } from './Sent';
import { TimeRangeField } from 'components/common/fields/DateTimeFields';
import CustomIcon from 'components/common/CustomIcon';

export const Time = (props) => (
    <span className="date-block">
        <TimeRangeField time={props.value} />
    </span>
);

export const Date = (props) => (
    <span className="date-block">
        <CustomIcon type="calendar-o" />
        <TextLine className="date" value={formatDate(props.value)} />
    </span>
);

export const SentDate = (props) => (
    <span className="date-block">
        <CustomIcon type="calendar-o" />
        <TextLine className="date" {...props} />
        <Sent {...props} />
    </span>
);
